export async function getTokenTempo() {
  const refreshTokenTempo = localStorage.getItem("refreshTokenTempo");
  return refreshTokenTempo;
}

export async function getTokenOtp() {
  const refreshTokenOtp = localStorage.getItem("refreshTokenOtp");
  return refreshTokenOtp;
}